import { render, staticRenderFns } from "./ReadMessages.vue?vue&type=template&id=a0ee6956&scoped=true&"
import script from "./ReadMessages.vue?vue&type=script&lang=js&"
export * from "./ReadMessages.vue?vue&type=script&lang=js&"
import style0 from "./ReadMessages.vue?vue&type=style&index=0&id=a0ee6956&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0ee6956",
  null
  
)

export default component.exports